import * as Highcharts from 'highcharts';

export const CHART_TOOLTIP_BACKGROUND = 'rgba(247, 247, 247, 0.85)';

export function applyGlobalChartTheme(): void {
  Highcharts.setOptions({
    tooltip: {
      backgroundColor: CHART_TOOLTIP_BACKGROUND
    }
  });
}
